export const MyCoupon = {
  SPECIAL_FOR_YOU_TITLE: 'คูปองพิเศษเฉพาะคุณ',
  COUPON_LOTUS_TITLE: 'คูปองโลตัส',
  COUPON_LIFESTYLE_TITLE: 'รีวอร์ด',
  COUPON_VOUCHER_TITLE: 'คูปองเงินสดโลตัส',
  COUPON_PREMIUM_TITLE: 'คูปองส่วนลด',
  VIEW_ALL: 'ดูทั้งหมด',
  IFRAME_NAME: 'iframe-my-coupon',
  LOTUS: 'lotus',
  LIFESTYLE: 'lifestyle',
  OFFER: 'offer',
  COUPON: 'coupon',
  ALL: 'all',
  SPECIAL_FOR_U: 'specialForU',
  VOUCHER: 'voucher',
  DISCOUNT: 'discount'
}

export const MyCouponType = {
  SPECIAL_FOR_YOU: 'SpecialForYou'
}
